import { cn } from "@heroui/react";
import { Check } from "lucide-react";

const CIRCLE_RADIUS = 16;
const DIVIDER_GAP = 0;

const Stepper = ({ steps, setActiveStep, activeStep, completedSteps, className }) => {
  const stepsLength = steps.length;

  const handleStepClick = (step) => {
    if (!completedSteps.includes(step.id)) return;
    setActiveStep(step.id);
  };

  return (
    <div className={cn("grid w-full", className)} style={{ gridTemplateColumns: `repeat(${stepsLength}, 1fr)` }}>
      {steps.map((step, i) => {
        const isActive = step.id === activeStep;
        const isCompleted = completedSteps.includes(step.id);
        const isLast = i === steps.length - 1;

        return (
          <div
            key={step.id}
            className={cn(
              "relative flex flex-col items-center cursor-not-allowed",
              isCompleted && "cursor-pointer group",
            )}
            onClick={() => handleStepClick(step)}
          >   
            {!isLast && (
              <div
                className={cn(
                  "absolute h-[1.5px] top-4 transition-colors duration-500",
                  isCompleted ? "bg-accent dark:bg-white" : "bg-background dark:bg-white",
                )}
                style={{
                  left: `calc(50% + ${CIRCLE_RADIUS + DIVIDER_GAP}px)`,
                  right: `calc(-50% + ${CIRCLE_RADIUS + DIVIDER_GAP}px)`,
                }}
              />
            )}

            {isCompleted && (
              <div className="absolute -top-4 left-1/2 -translate-x-1/2">
                <Check size={14} className="text-accent" />
              </div>
            )}

            <div
              className={cn(
                "relative z-10 h-8 w-8 bg-background dark:bg-white dark:text-black shiny-shadow! text-sm font-medium rounded-full transition-all duration-500 flex justify-center items-center",
                isActive || isCompleted ? "bg-accent text-surface" : "text-foreground dark:opacity-50",
                isCompleted ? "group-hover:opacity-100" : '',
                isActive && "opacity-100",
              )}
            >
              {isCompleted ? <Check size={16} /> : i + 1}
            </div>

            <div
              className={cn(
                "text-center text-xs mt-2 transition-all duration-500 text-foreground font-normal leading-snug w-3/5",
                isActive || isCompleted ? "text-accent dark:text-white" : "",
                isCompleted && "group-hover:opacity-100",
                isActive && "opacity-100",
              )}
            >
              {step.label}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default Stepper;
